<template>
  <div class="container">
    <h1>标签打印</h1>
    <a-input-search placeholder="IMEI码" v-model="imei" style="width: 400px;height:45px" 
    :maxLength="15" @search="onSearch" ref="inputs" />
    <img src="@/assets/imgs/tagprint.png" />
    <div class="tip">
      <p>1、确保标签打印机和扫码枪与电脑连接，确保光标在搜索框中。</p>
      <p>2、将扫码枪对准模块上的二维码，“滴”的一声系统自动打印出标签。</p>
      <p>3、将打印出来的标签与电路板一同装进防静电袋中。</p>
    </div>
    <!-- 打印 -->
    <tagPrint
    :collector="collectorItem"
    ref="print"
    ></tagPrint>
  </div>
</template>

<script>
import tagPrint from '../collector/CollectorPrint'
export default {
  name: 'MonitorView',
  components: {tagPrint},
  data () {
      return {
          collectorItem: {
            name: '',
            mfd: '',
            type: 0
          },
          imei: ''
      }
  },
  mounted () {
    HTMLElement.prototype.pressKey = function(code) {
        console.log(code)
        var evt = document.createEvent("UIEvents");
        evt.keyCode = code;
        evt.initEvent("keydown", true, true);
        this.dispatchEvent(evt);
    }
    this.getFocus()
  },
  beforeRouteEnter  (to, from, next) {
    next(vm => vm.getFocus())
  },
  methods: {
    getFocus () {
        this.imei = ''  
        this.$refs.inputs.focus()
    },
    print () {
      this.$nextTick(() => {
        this.$refs.print.printclick()
      })
    },
    onSearch () {
        this.$get('collector', {
            imei: this.imei
        }).then(res => {
            console.log(res)
            if (res.data.rows.length === 1) {
                this.collectorItem = res.data.rows[0]
                this.collectorItem.imeiList = this.imei.split('')
                // setTimeout(() => {
                //     console.log(111)
                //     document.body.pressKey(13);
                // }, 6000)
                this.print()
            } else if (res.data.rows.length === 0) {
                this.$message.warning('暂不存在该IMEI码')
            } else {
                this.$message.warning('该IMEI码不唯一，请准确输入')
            }
            setTimeout(() => {
                this.getFocus()
            }, 1000)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.container{
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 50px;
  & h1{
    // margin-top: 100px;
    font-size: 35px;
  }
  & img {
    margin: 50px 0;
    width: 50%;
  }
  .tip{
    & p {
      font-weight: 600;
      font-size: 16px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/business/tagprint/TagPrint.vue